import { render } from "./Streak.vue?vue&type=template&id=56e3043a"
import script from "./Streak.vue?vue&type=script&lang=js"
export * from "./Streak.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/pro/Plugins/Streak.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56e3043a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56e3043a', __exports__)) {
    api.reload('56e3043a', __exports__)
  }
  
  module.hot.accept("./Streak.vue?vue&type=template&id=56e3043a", () => {
    api.rerender('56e3043a', render)
  })

}


export default __exports__